import { z } from 'zod';

const nullishToUndefined = (value: unknown): unknown => (
  value == null ? undefined : value
);

export const optionalNullishInput = <TSchema extends z.ZodTypeAny>(
  schema: TSchema
) => z.preprocess(nullishToUndefined, schema.optional());

export const OptionalNonEmptyStringInput = optionalNullishInput(
  z.string().trim().min(1)
);
